<template>
	<div class="content" style="background-color: #103037; border-radius: 15px;padding: 0px 0px">
		<loading v-if="!loaded"/>
		<iframe :src="url" frameborder="0" v-if="url.length > 0" style="width: 100%;height: 680px; border-radius: 15px;"></iframe>
	</div>
</template>

<script>

	export default {
		components: {

		},
		mounted() {
			window.scrollTo(0,0);
		},
		created() {
			this.openGame(this.$route.params.hash_id);
		},
		methods: {
			openGame(hash) {
				if(this.$store.state.authentication.loggedIn) {
					// this.$store.state.authentication.loading = true;
					this.$http.get(this.config.api + "/user/authed/game/open/" + hash).then(res => {
						this.$store.state.authentication.loading = false;
						if (res.body.status == 'success') {
							this.loaded = true;
							this.url = res.body.data.url;
						}
					})
				} else {
					this.$router.push("/login");
				}
			}
		},
		computed: {
		},
		data() {
			return {
				loaded: false,
				url: ""
			}
		}
	}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/Play.vue